import AxiosCustom from "../../common/components/apiConfig"

export function pishroKycOtp(national_id, is_individual) {
    let config = {
      url: "login"
    }
  
    let data = {
      table: "clubmember",
      method_type: "pishro_send_kyc_otp",
      token:'3cf61fab-b50a-410f-9d59-3357ee4706fe',
      member_id:'_0zehXYBdxxYGfkX5_wd',
      data: {
        national_id,
        is_individual,
      }
    }
  
    return AxiosCustom(config, data)
  }